"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomRepetition = void 0;
const CustomRepetitionType_1 = __importDefault(require("../CustomRepetitionType"));
function createCustomRepetition() {
    return {
        customRepetitionType: CustomRepetitionType_1.default.WEEKLY,
        weekdays: [1, 2, 3, 4, 5],
        datesOfMonth: [1],
        weeksOfMonth: [1],
        monthsOfYear: [1],
        last: false,
    };
}
exports.createCustomRepetition = createCustomRepetition;
exports.default = createCustomRepetition;
